import { ErrorTrade } from './ErrorTrade';

export class DiffToolPreload {
  id: number;
  source: string;
  goldenRecordUniqueId: string;
  accountId: number;
  serialId: number;
  errorTime: number;
  valueDate: number;
  errorCode: string;
  goldenRecordErrorTrade: ErrorTrade;
  abosErrorTrade: ErrorTrade;
}
